
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useFormContext } from "react-hook-form";

interface PriceInputProps {
  disabled?: boolean;
}

export const PriceInput = ({ disabled = false }: PriceInputProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name="price"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Price</FormLabel>
          <FormControl>
            <Input
              type="number"
              placeholder="0"
              {...field}
              onChange={(e) => field.onChange(parseFloat(e.target.value) || 0)}
              disabled={disabled}
              value={disabled ? 0 : field.value}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
